import { INewbuildingBuilder } from '../../../types/developer/builder';
import { INewbuildingSeller } from '../../../types/developer/sellers';
import { phoneToString } from '../../../utils';

export const getPhoneLabel = (builders: INewbuildingBuilder[], sellers: INewbuildingSeller[]) => {
  if (builders.length > 0) {
    return 'Позвонить застройщику';
  }

  const isKpn = Boolean(sellers.find(seller => seller.isLeadFactory));

  return isKpn ? 'Позвонить консультанту' : 'Позвонить застройщику';
};

export const getSinglePhone = (builders: INewbuildingBuilder[], sellers: INewbuildingSeller[]) => {
  const contact = builders[0] || sellers[0];

  return phoneToString(contact?.phone);
};

export const getSingleSiteBlockId = (builders: INewbuildingBuilder[], sellers: INewbuildingSeller[]) => {
  const contact = builders[0] || sellers[0];

  return contact?.dynamicCalltracking?.siteBlockId;
};
